import { render, staticRenderFns } from "./CoachAwardRow.vue?vue&type=template&id=377f5374&"
import script from "./CoachAwardRow.vue?vue&type=script&lang=ts&"
export * from "./CoachAwardRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports